const items = [
  "CORTISOLO ZERO",
  "ALTA PERFORMANCE",
  "ATTENUAZIONE BIOLOGICA",
  "JOE FENIX METHOD",
  "ENERGIA MITOCONDRIALE",
];

export default function Marquee() {
  const half = [...items, ...items];
  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-[#D4AF37]/15 py-7"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0">
            {half.map((t, i) => (
              <span
                key={`${dup}-${i}`}
                className="flex items-center whitespace-nowrap font-serif-lux text-xl italic text-[#D4AF37]/75 md:text-2xl"
              >
                <span className="px-8">{t}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#B87333]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
